import {gql} from '@apollo/client'
import {FileFormType} from 'libs/formatter'

export const PROCEDURE_ATTACHMENTS_FORM = gql`
  query procedureAttachmentsForm($procedureStatusId: ID!) {
    client {
      id
      procedureStatus(procedureStatusId: $procedureStatusId) {
        id
        procedureType
        employee {
          id
          staffCode
          displayFullName
        }
        procedureAttachments {
          id
          file
        }
      }
    }
  }
`

export interface ProcedureAttachmentsFormQueryVariables {
  procedureStatusId: string
}

export interface ProcedureAttachmentsFormQueryResult {
  client: {
    id: string
    procedureStatus: {
      id: string
      procedureType: string
      employee: {
        id: string
        staffCode: string
        displayFullName: string
      }
      procedureAttachments: {
        id: string
        file: {
          filename: string
          url: string
        }
      }[]
    }
  }
}

export const UPDATE_PROCEDURE_ATTACHMENTS = gql`
  mutation updateProcedureAttachments($input: UpdateProcedureAttachmentsInput!) {
    updateProcedureAttachments(input: $input) {
      procedureStatus {
        id
        procedureAttachments {
          id
          file
        }
      }
    }
  }
`

export interface UpdateProcedureAttachmentsQueryVariables {
  input: {
    procedureStatusId: string
    attachments: {
      id?: string | null
      file: FileFormType | File
    }[]
    byAdmin: boolean
  }
}

export interface UpdateProcedureAttachmentsQueryResult {
  updateProcedureAttachments: {
    procedureStatus: {
      id: string
      procedureAttachments: {
        id: string
        file: {
          filename: string
          url: string
        }
      }[]
    }
  }
}
